import type React from 'react'
import type { ToggleButtonProps, ToggleGroupProps } from './ToggleButton.types'
import * as ToggleGroupPrimitives from '@radix-ui/react-toggle-group'
import cn from 'classnames'
import { Typography } from '../typography'
import styles from './ToggleButton.module.css'

export function ToggleButton({ ref, title, className, children, size = 'M', color = 'selected', disabled, ...rest }: ToggleButtonProps & React.PropsWithChildren) {
  return (
    <ToggleGroupPrimitives.Item
      className={cn(
        styles.toggleButton,
        {
          [styles.sizeM]: size === 'M',
          [styles.sizeS]: size === 'S',
          [styles.colorSelected]: color === 'selected',
          [styles.colorNeutral]: color === 'neutral',
          [styles.disabled]: disabled,
        },
        className,
      )}
      disabled={disabled}
      ref={ref}
      {...rest}
    >
      {title && <Typography className={styles.typography}>{title}</Typography>}
      {children}
    </ToggleGroupPrimitives.Item>
  )
}

export function ToggleButtonGroup({ ...props }: ToggleGroupProps) {
  return <ToggleGroupPrimitives.Root {...props} />
}

export default ToggleButton
